module.exports = __webpack_public_path__ + "static/assets/b310bd0a8bf282694a3ebb8d8d0136d8.png";